$mol_icon_flag $mol_icon path \M14.4,6L14,4H5V21H7V14H12.6L13,16H20V6H14.4Z
